import axios from "axios";
import CalenderService from '../../service/calender';
import dateUtil from '../../util/dateUtil';
import moment from 'moment';

const Action = {
    GET_EVENTS: '[CALENDAR APP] GET EVENTS',
    GET_DATE_EVENTS: '[CALENDAR APP] GET_DATE_EVENTS',
    OPEN_NEW_EVENT_DIALOG: '[CALENDAR APP] OPEN NEW EVENT DIALOG',
    CLOSE_NEW_EVENT_DIALOG: '[CALENDAR APP] CLOSE NEW EVENT DIALOG',
    OPEN_EDIT_EVENT_DIALOG: '[CALENDAR APP] OPEN EDIT EVENT DIALOG',
    CLOSE_EDIT_EVENT_DIALOG: '[CALENDAR APP] CLOSE EDIT EVENT DIALOG',
    ADD_EVENT: '[CALENDAR APP] ADD EVENT',
    UPDATE_EVENT: '[CALENDAR APP] UPDATE EVENT',
    REMOVE_EVENT: '[CALENDAR APP] REMOVE EVENT',
};

const ActionCreator = {
    getEvents() {
        return async (dispatch) => {
            try {
                const medicalId = 5;
                const events = await CalenderService.list(medicalId);
                dispatch({type: Action.GET_EVENTS, payload: events});
                return events;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getDateWorkEvents({date}) {
        return async (dispatch) => {
            try {
                let workEvents = await CalenderService.workEventListByDate(date);
                workEvents = workEvents.filter(workEvent => workEvent.fk_mpt_id === 1)
                workEvents = workEvents.sort(function (a, b) {
                    return a.fk_time_period_id > b.fk_time_period_id ? 1 : -1;
                });

                const lmWorkEvents = await CalenderService.lmWorkEventListByDate(date);

                const fmWorkEvents = await CalenderService.fmWorkEventListByDate(date);
                // 顯示 月 . 周 . 日 , 各時段 . 各種醫生共幾個

                let counter = 0;

                const transferWorkEvent = function (workEvent) {
                    return {id: ++counter, name: workEvent.medical.user.name, institution: workEvent.medical.institution.name, start: workEvent.time_period.start_time, end:workEvent.time_period.end_time, timerPeriod: workEvent.time_period.name, timePeriodId: workEvent.fk_time_period_id};
                };

                const transferLmWorkEvent = function (lmWorkEvent) {
                    return {id: ++counter, name: lmWorkEvent.medical.user.name, institution: lmWorkEvent.medical.institution.name};
                };

                const transferFmWorkEvent = function (fmWorkEvent) {
                    return {id: ++counter, name: fmWorkEvent.medical.user.name, institution: fmWorkEvent.medical.institution.name};
                };


                const new_date_events = workEvents.map((workEvent, index) => {
                    return transferWorkEvent(workEvent, index);
                });

                const new_date_lm_events = lmWorkEvents.map((lmWorkEvent, index) => {
                    return transferLmWorkEvent(lmWorkEvent, index);
                });

                const new_date_fm_events = fmWorkEvents.map((fmWorkEvent, index) => {
                    return transferFmWorkEvent(fmWorkEvent, index);
                });

                dispatch({type: Action.GET_DATE_EVENTS, payload: { new_date_events, new_date_lm_events, new_date_fm_events}});
                return new_date_events;

            } catch (error) {
                throw dispatch({error});
            }
        };
    },

    getMonthlyWorkEvents({year, month}) {
        return async (dispatch) => {
            try {
                const dateArray = dateUtil.getEveryDateOfMonth({year, month: month - 1, timezone: 8});

                let workEvents = await Promise.all(dateArray.map(async (date) => {
                    return await CalenderService.workEventListByDate(dateUtil.format({date}));
                }));



                const lmWorkEvents = await Promise.all(dateArray.map(async (date) => {
                    return await CalenderService.lmWorkEventListByDate(dateUtil.format({date}));
                }));

                const fmWorkEvents = await Promise.all(dateArray.map(async (date) => {
                    return await CalenderService.fmWorkEventListByDate(dateUtil.format({date}));
                }));

                let counter = 0;

                let new_events = [];
                workEvents.forEach(workEventsDay => {
                    let weFilteredArr = workEventsDay.filter( we => we.fk_mpt_id ===1)
                    if(weFilteredArr.length > 0){
                        const start_time_int = weFilteredArr[0].time_period.start_time_int;
                        const end_time_int = weFilteredArr[0].time_period.end_time_int;
                        const date = weFilteredArr[0].date;
                        const start_date = new Date(moment(date).toDate().getTime() + start_time_int);
                        const end_date = new Date(moment(date).toDate().getTime() + end_time_int);
                        new_events.push({
                            id: ++counter, title: `有${weFilteredArr.length}個 一線排班`, allDay: false, start: start_date, end: end_date, level:1
                        })
                    }
                });

                let new_lm_events = [];
                lmWorkEvents.forEach(workEventsDay => {
                    if(workEventsDay.length > 0){
                        const date_str = workEventsDay[0].date_str;
                        const start_date = moment(date_str).startOf('day').toDate();
                        const end_date = moment(date_str).endOf('day').toDate();
                        // return {};
                        new_lm_events.push({
                            id: ++counter, title: `有${workEventsDay.length}個 總值排班`, allDay: false, start: start_date, end: end_date, level:2
                        })
                    }
                });

                let new_fm_events = [];
                fmWorkEvents.forEach(workEventsDay => {
                    if(workEventsDay.length > 0){
                        const date_str = workEventsDay[0].date_str;
                        const start_date = moment(date_str).startOf('day').toDate();
                        const end_date = moment(date_str).endOf('day').toDate();
                        // return {};
                        new_fm_events.push({
                            id: ++counter, title: `有${workEventsDay.length}個 救火排班`, allDay: false, start: start_date, end: end_date, level:3
                        })
                    }
                });

                dispatch({type: Action.GET_EVENTS, payload: [...new_events, ...new_lm_events, ...new_fm_events]});
                return new_events;

            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getWorkEvents({startDate, endDate}) {
        return async (dispatch) => {
            try {

                const dateArray = dateUtil.getDailyDateArray({startDate, endDate});

                const workEventsArray = await Promise.all(dateArray.map(async (date) => {
                    return await CalenderService.workEventListByDate(dateUtil.format({date}));
                }));

                const lmWorkEventsArray = await Promise.all(dateArray.map(async (date) => {
                    return await CalenderService.lmWorkEventListByDate(dateUtil.format({date}));
                }));

                const fmWorkEventsArray = await Promise.all(dateArray.map(async (date) => {
                    return await CalenderService.fmWorkEventListByDate(dateUtil.format({date}));
                }));

                // 顯示 月 . 周 . 日 , 各時段 . 各種醫生共幾個

                let counter = 0;

                const nmWorkEvents = workEventsArray.reduce((pre, curr) => [...pre, ...curr]);
                const lmWorkEvents = lmWorkEventsArray.reduce((pre, curr) => [...pre, ...curr]);
                const fmWorkEvents = fmWorkEventsArray.reduce((pre, curr) => [...pre, ...curr]);

                const nmWorkEvents_type2 = workEventsArray.map((oneDayWorkEvents) => {

                    function groupBy(array, f) {
                        let groups = {};
                        array.forEach(function (o) {
                            let group = JSON.stringify(f(o));
                            groups[group] = groups[group] || [];
                            groups[group].push(o);
                        });
                        return Object.keys(groups).map(function (group) {
                            return groups[group];
                        });
                    }

                    const periodlyWorkEvents = groupBy(oneDayWorkEvents, function (item) {
                        return [item.time_period.label];
                    });

                    return periodlyWorkEvents.map((onePeriodWorkEvents) => {

                        const workEvent = onePeriodWorkEvents[0];
                        const date = workEvent.date;
                        const start_time_int = workEvent.time_period.start_time_int;
                        const end_time_int = workEvent.time_period.end_time_int;
                        const start_date = new Date(moment(date).startOf('day').toDate().getTime() + start_time_int);
                        const end_date = new Date(moment(date).startOf('day').toDate().getTime() + end_time_int);
                        const number = onePeriodWorkEvents.length;

                        return {
                            id: ++counter,
                            title: `${number}個急診醫師排班`,
                            allDay: false,
                            start: start_date,
                            end: end_date
                        };
                    });

                }).reduce((pre, curr) => [...pre, ...curr]);

                const lmWorkEvents_type2 = lmWorkEventsArray.map((oneDayLmWorkEvents) => {

                    if (oneDayLmWorkEvents.length === 0) return {};

                    const lmWorkEvent = oneDayLmWorkEvents[0];
                    const date_str = lmWorkEvent.date_str;
                    const start_date = moment(date_str).startOf('day').toDate();
                    const end_date = moment(date_str).endOf('day').toDate();
                    const number = oneDayLmWorkEvents.length;
                    return {id: ++counter, title: `${number}個總值醫師排班`, allDay: true, start: start_date, end: end_date};
                }).filter(lmWorkEvent => !!(lmWorkEvent.start));

                const fmWorkEvents_type2 = fmWorkEventsArray.map((oneDayFmWorkEvents) => {

                    if (oneDayFmWorkEvents.length === 0) return {};

                    const fmWorkEvent = oneDayFmWorkEvents[0];
                    const date_str = fmWorkEvent.date_str;
                    const start_date = moment(date_str).startOf('day').toDate();
                    const end_date = moment(date_str).endOf('day').toDate();
                    const number = oneDayFmWorkEvents.length;
                    return {id: ++counter, title: `${number}個救火醫師排班`, allDay: true, start: start_date, end: end_date};
                }).filter(fmWorkEvent => !!(fmWorkEvent.start));

                const datas = {
                    // payload: [...new_events, ...new_lm_events, ...new_fm_events],
                    payload: [...nmWorkEvents_type2, ...lmWorkEvents_type2, ...fmWorkEvents_type2],
                    nmWorkEvents,
                    lmWorkEvents,
                    fmWorkEvents,
                    startDate,
                    endDate
                };

                return dispatch({type: Action.GET_EVENTS, ...datas});

            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    openNewEventDialog(data) {
        return {
            type: Action.OPEN_NEW_EVENT_DIALOG,
            data
        }
    },
    closeNewEventDialog() {
        return {
            type: Action.CLOSE_NEW_EVENT_DIALOG
        }
    },
    openEditEventDialog(data) {
        return {
            type: Action.OPEN_EDIT_EVENT_DIALOG,
            data
        }
    },
    closeEditEventDialog() {
        return {
            type: Action.CLOSE_EDIT_EVENT_DIALOG
        }
    },
    addEvent(newEvent) {
        return (dispatch, getState) => {

            const request = axios.post('/api/calendar-app/add-event', {
                newEvent
            });

            return request.then((response) =>
                Promise.all([
                    dispatch({
                        type: Action.ADD_EVENT
                    })
                ]).then(() => dispatch(ActionCreator.getEvents()))
            );
        };
    },
    updateEvent(event) {
        return (dispatch, getState) => {

            const request = axios.post('/api/calendar-app/update-event', {
                event
            });

            return request.then((response) =>
                Promise.all([
                    dispatch({
                        type: Action.UPDATE_EVENT
                    })
                ]).then(() => dispatch(ActionCreator.getEvents()))
            );
        };
    },
    removeEvent(eventId) {
        return (dispatch, getState) => {

            const request = axios.post('/api/calendar-app/remove-event', {
                eventId
            });

            return request.then((response) =>
                Promise.all([
                    dispatch({
                        type: Action.REMOVE_EVENT
                    })
                ]).then(() => dispatch(ActionCreator.getEvents()))
            );
        };
    },
};


const initialState = {
    entities: [],
    nmWorkEvents: [],
    lmWorkEvents: [],
    fmWorkEvents: [],
    consultingHours: [],
    new_date_events: [],
    new_date_lm_events: [],
    new_date_fm_events: [],
    eventDialog: {
        type: 'new',
        props: {
            open: false
        },
        data: null
    }
};


const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_EVENTS: {
            const entities = action.payload.map((event) => (
                {
                    ...event,
                    start: new Date(event.start),
                    end: new Date(event.end)
                }
            ));

            return {
                ...state,
                entities,
                nmWorkEvents: action.nmWorkEvents,
                lmWorkEvents: action.lmWorkEvents,
                fmWorkEvents: action.fmWorkEvents,
                consultingHours: action.consultingHours,
                startDate: action.startDate,
                endDate: action.endDate,
            };
        }
        case Action.GET_DATE_EVENTS: {
            return {
                ...state,
                new_date_events: action.payload.new_date_events,
                new_date_lm_events: action.payload.new_date_lm_events,
                new_date_fm_events: action.payload.new_date_fm_events,
            };
        }
        case Action.OPEN_NEW_EVENT_DIALOG: {
            return {
                ...state,
                eventDialog: {
                    type: 'new',
                    props: {
                        open: true
                    },
                    data: {
                        ...action.data
                    }
                }
            };
        }
        case Action.CLOSE_NEW_EVENT_DIALOG: {
            return {
                ...state,
                eventDialog: {
                    type: 'new',
                    props: {
                        open: false
                    },
                    data: null
                }
            };
        }
        case Action.OPEN_EDIT_EVENT_DIALOG: {
            return {
                ...state,
                eventDialog: {
                    type: 'edit',
                    props: {
                        open: true
                    },
                    data: {
                        ...action.data,
                        start: new Date(action.data.start),
                        end: new Date(action.data.end)
                    }
                }
            };
        }
        case Action.CLOSE_EDIT_EVENT_DIALOG: {
            return {
                ...state,
                eventDialog: {
                    type: 'edit',
                    props: {
                        open: false
                    },
                    data: null
                }
            };
        }
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/calender.js